import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';

/**
 *  1:1 문의 리스트 필터 옵션 모델
 */
export const CS_INQUIRY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  답변 처리 상태
   */
  isResponse: null,
  /**
   *  1:1 문의 ID
   */
  inquiryId: null,
  /**
   *  질문 유형
   */
  type: null,
  /**
   *  구매자 ID
   */
  buyerId: null,
  /**
   *  질문내용
   */
  question: null,
  /**
   *  답변내용
   */
  answer: null,
  /**
   *  답변 작성자
   */
  replyAuthor: null,
  /**
   *  답변 작성자 메모
   */
  memo: null,
  /**
   *  답변 일자
   */
  answerDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  질문 작성 일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  주문여부
   */
  isOrderInquiry: null,
  /**
   *  주문상태
   */
  orderItemStatus: null,
};

/**
 *  1:1 문의 리스트 필터 옵션 모델
 */
export const CS_INQUIRY_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  1:1 문의 상세 유저 정보 모델
 */
export const CS_INQUIRY_DETAIL_USER_INFO_MODEL = {
  /**
   *  유저 식별 ID
   */
  userId: null,
  /**
   *  로그인 타입
   */
  loginType: null,
  /**
   *  이메일
   */
  email: null,
  /**
   *  핸드폰 번호
   */
  cellPhone: null,
  /**
   *  유저명
   */
  name: null,
  /**
   *  생년월일
   */
  birthday: null,
  /**
   *  성별
   */
  gender: null,
  /**
   *  친구초대 코드
   */
  referralCode: null,
  /**
   *  계정 상태
   */
  status: null,
  /**
   *  가입일자
   */
  createDate: null,
  /**
   *  기종명
   */
  modelName: null,
  /**
   *  os 종류 및 버전
   */
  os: null,
  /**
   *  기기 sdk 버전
   */
  sdk: null,
  /**
   *  AMONDZ 앱 버전
   */
  appVersion: null,
  /**
   *  최근에 주문한 주문서 정보
   */
  latestOrderItemList: [],
  /**
   *  유저의 다른 문의 내역 조회하기
   */
  usersOtherInquiry: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },
};

/**
 *  1:1 문의 상세 문의 정보 모델
 */
export const CS_INQUIRY_DETAIL_INQUIRY_INFO_MODEL = {
  /**
   *  유저 식별 id
   */
  userId: null,
  /**
   *  1:1 문의 상세 id
   */
  inquiryId: null,
  /**
   *  1:1 문의 답변 여부
   */
  isResponse: false,
  /**
   *  첨부파일 리스트
   */
  attachments: [],
  /**
   *  문의 유형
   */
  type: null,
  /**
   *  질문 일시
   */
  createDate: null,
  /**
   *  질문 내용
   */
  question: null,
  /**
   *  답변
   */
  answer: null,
  /**
   *  답변 작성 일시
   */
  answerDate: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  답변 작성자
   */
  replyAuthor: null,
  /**
   *  주문여부
   */
  isOrderInquiry: null,
  /**
   *  주문상태
   */
  orderItemStatus: null,
};
